import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { useTheme } from 'styled-components';

const CompareDamagesIconSvg = () => {
  const theme = useTheme();

  return (
    <svg width="1em" height="1em" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
      <rect x="7" y="7" width="114" height="114" rx="18" fill={theme.buttonBackgroundColor} />
      <rect
        x="7"
        y="7"
        width="114"
        height="114"
        rx="18"
        fill="none"
        stroke={theme.contrastColor}
        strokeWidth="6"
      />

      <path d="M64 7V44" fill="none" stroke={theme.contrastColor} strokeWidth="6" />
      <path d="M64 79V121" fill="none" stroke={theme.contrastColor} strokeWidth="6" />

      <path
        d="M49 29V46H64V58H49V76L26 52.5L49 29Z"
        fill={theme.buttonBackgroundColor}
        stroke={theme.contrastColor}
        strokeWidth="6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M79 49V42L102 65L79 88V71H64V58H79V49Z"
        fill={theme.buttonBackgroundColor}
        stroke={theme.contrastColor}
        strokeWidth="6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

// By passing size value, we can control height and width of this icon
// By passing verticalAlign, we can override antd icon default vertical alignment
export const CompareDamagesIcon = (
  props: Partial<CustomIconComponentProps> & { size?: number; verticalAlign?: string }
) => (
  <Icon
    component={CompareDamagesIconSvg}
    style={{ fontSize: props.size || 24, verticalAlign: props.verticalAlign ?? 'baseline' }}
    {...props}
  />
);
